export default "skymp5-front/2d45d5f75c74bbf47f231dd420bb50e4.svg";